"use client";

import { useCallback, useEffect, useRef, useState } from "react";

const DEFAULT_COOLDOWN_SECONDS = 30;

/**
 * Countdown that gates the "send the code again" action. Shared by the sign-up
 * and password-reset code steps.
 */
export const useResendCooldown = (
  seconds: number = DEFAULT_COOLDOWN_SECONDS,
) => {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const clear = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  useEffect(() => clear, [clear]);

  const start = useCallback(() => {
    clear();
    setSecondsLeft(seconds);

    intervalRef.current = setInterval(() => {
      setSecondsLeft((current) => {
        if (current <= 1) {
          clear();
          return 0;
        }

        return current - 1;
      });
    }, 1000);
  }, [clear, seconds]);

  return { secondsLeft, isCoolingDown: secondsLeft > 0, start };
};
